import {
  Component,
  OnInit,
  TemplateRef,
  ViewChild,
  inject,
} from '@angular/core';
import { MessageService } from './message.service';
import {
  NzNotificationDataOptions,
  NzNotificationService,
} from 'ng-zorro-antd/notification';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { notificationConfig } from '../shared/configs';

export enum ENotificationType {
  SUCCESS,
  ERROR,
}

@UntilDestroy()
@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss'],
})
export class MessageComponent implements OnInit {
  @ViewChild('notificationTemplate')
  notificationTemplate!: TemplateRef<object>;

  @ViewChild('notificationCloseSuccess')
  notificationCloseSuccess!: TemplateRef<void>;

  @ViewChild('notificationCloseError')
  notificationCloseError!: TemplateRef<void>;

  private _messageService: MessageService = inject(MessageService);
  private _notificationService: NzNotificationService = inject(
    NzNotificationService
  );

  public notificationType = ENotificationType;

  public ngOnInit(): void {
    this._messageService.success$.pipe(untilDestroyed(this)).subscribe({
      next: (message: string) => {
        this.showSuccess(message);
      },
    });

    this._messageService.error$.pipe(untilDestroyed(this)).subscribe({
      next: (message: string) => {
        this.showError(message);
      },
    });
  }

  public showError(message: string): void {
    this._notificationService.template(
      this.notificationTemplate,
      this._getErrorConfig(message)
    );
  }

  public showSuccess(message: string): void {
    this._notificationService.template(
      this.notificationTemplate,
      this._getSuccessConfig(message)
    );
  }

  private _getSuccessConfig(message: string): NzNotificationDataOptions {
    return {
      ...notificationConfig,
      nzClass: 'ml-notification success',
      nzCloseIcon: this.notificationCloseSuccess,
      nzData: {
        title: 'Success Message',
        message: `${message}`,
        type: ENotificationType.SUCCESS,
      },
    } as NzNotificationDataOptions;
  }

  private _getErrorConfig(message: string): NzNotificationDataOptions {
    return {
      ...notificationConfig,
      nzClass: 'ml-notification danger',
      nzCloseIcon: this.notificationCloseError,
      nzData: {
        title: 'Error Message',
        message: `${message}`,
        type: ENotificationType.ERROR,
      },
    } as NzNotificationDataOptions;
  }
}
